import { AloBase, getDefaultAloBase } from './AloBase'
import { AloMailTemplateLg } from './AloMailTemplateLg'


export interface AloMailTemplate extends AloBase {              
    mtpValide:boolean    
    mskId:number|null
    lgs:Array<AloMailTemplateLg>    
}

export const getDefaultAloMailTemplate = ():AloMailTemplate => {
    return {        
        ...getDefaultAloBase(),        
        mtpValide:true,
        mskId:2,
        lgs:[]

    }
}

export const cleanAloMailTemplate = (mailTemplate:AloMailTemplate) => {
    if(!mailTemplate) return    
    if(!mailTemplate.id) delete mailTemplate.id
    if(!mailTemplate.mskId) delete mailTemplate.mskId
}
